module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "copy2"
  }, [_vm._v("Copyright © 1995 by Ginu Kamani")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. This book, or parts thereof, must not be reproduced in any form without written permission from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("First Edition")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("10 9 8 7 6 5 4 3")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Aunt Lute Books")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("PO Box 410687")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("San Francisco, CA 94141")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("This book was funded in part by a grant from the National Endowment for the Arts. This is a work of fiction. In no way does it intend to represent any real person, living or dead, or any real incidents.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("“Maria” and “Waxing The Thing” first appeared in "), _c('i', [_vm._v("Our Feet Walk the Sky: Women of the South Asian Diaspora,")]), _vm._v(" ed. The Women of South Asian Descent Collective (San Francisco: Aunt Lute Books, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Cover Art: “Nayika” by Gogi Saroj Pal")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Cover and Text Design: Pamela Wilson Design Studio")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Typesetting: JBWiley, Drago Design")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Senior Editor: Joan Pinkvoss")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Managing Editor: Christine Lymbertos")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "copy1"
  }, [_vm._v("Production:")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copy1"
  }, [_vm._v("Cristina Azócar"), _c('br'), _vm._v("Vita Iskandar")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copy1"
  }, [_vm._v("Jee Yeun Lee"), _c('br'), _vm._v("Kathleen Wilkinson")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "copy1"
  }, [_vm._v("Production Support:")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copy1"
  }, [_vm._v("Jonna K. Eagle"), _c('br'), _vm._v("Jamie Lee Evans"), _c('br'), _vm._v("Irma de Jesus")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copy1"
  }, [_vm._v("Melissa Levin"), _c('br'), _vm._v("Michelle Uribe"), _c('br'), _vm._v("Alexa Weinstein")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Printed in the U.S.A. on acid-free paper.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('b', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Kamani, Ginu, 1962–")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("Junglee Girl / by Ginu Kamani")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("   p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("ISBN 1–879960–41–9 — ISBN 1–879960–40–0 (pbk.) — Ebook ISBN 978–1–939904–11–9")]), _vm._v(" "), _c('p', {
    staticClass: "copyi"
  }, [_vm._v("1. Short Stories, Indic (English)    2. Social problems—Fiction.    3. Women—India—Social Life and customs—Fiction.    4. Women—India—Social conditions—Fiction.    5. United States—Social conditions—Fiction.      I. Title.")]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "copyi"
  }, [_vm._v("PR9497.32.K36    1995")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('p', {
    staticClass: "copyr"
  }, [_vm._v("94-46891")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "copyi"
  }, [_vm._v("823—dc20")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_c('p', {
    staticClass: "copyr"
  }, [_vm._v("CIP")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dd8b268","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copy.vue
// module id = 57
// module chunks = 0